/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */
import { L1_MENU_ID } from '@jira/navigation-apps__sidebar-nav4-sidebars-common-core/src/common/types.tsx';
import type { JiraUserNavigationConfiguration } from '../types.tsx';

export const PACKAGE_NAME = 'jiraNavigationAppsSidebarNav4SidebarContent';
export const TEAM_NAME = 'jira-cosmos';

export const USER_NAVIGATION_CONFIGURATION_DEFAULT: JiraUserNavigationConfiguration = {
	navKey: 'JIRA_SIDEBAR',
	navItems: [
		{
			menuId: L1_MENU_ID.RECENT,
			isVisible: true,
		},
		{
			menuId: L1_MENU_ID.STARRED,
			isVisible: true,
		},
		{
			menuId: L1_MENU_ID.APPS,
			isVisible: true,
		},
		// See https://jplat.jira.atlassian.cloud/browse/BLU-3307
		// For the Dogfooding phase of Nav4 we are going to intentionally hide the Goals menu item.
		// Keeping code in comments so it can be easily reintroduced during EAP
		// {
		// 	menuId: L1_MENU_ID.GOALS,
		// 	isVisible: true,
		// },
		{
			menuId: L1_MENU_ID.ROADMAPS,
			isVisible: true,
		},
		{
			menuId: L1_MENU_ID.PLANS,
			isVisible: true,
		},
		{
			menuId: L1_MENU_ID.PROJECTS,
			isVisible: true,
		},
		{
			menuId: L1_MENU_ID.FILTERS,
			isVisible: true,
		},
		{
			menuId: L1_MENU_ID.DASHBOARDS,
			isVisible: true,
		},
		{
			menuId: L1_MENU_ID.OPERATIONS,
			isVisible: true,
		},
		{
			menuId: L1_MENU_ID.ITAM,
			isVisible: true,
		},
		{
			/* remove this on
			 * assets_as_an_app_v2 cleanup &&
			 */
			menuId: L1_MENU_ID.ASSETS,
			isVisible: true,
		},
		{
			menuId: L1_MENU_ID.TEAMS,
			isVisible: true,
		},
		{
			menuId: L1_MENU_ID.CUSTOMERS,
			isVisible: true,
		},
		{
			menuId: L1_MENU_ID.CUSTOMER_SERVICE,
			isVisible: true,
		},
		{
			menuId: L1_MENU_ID.HELP_CENTER_MANAGEMENT,
			isVisible: true,
		},
		{
			menuId: L1_MENU_ID.GLOBAL_APP_CONFLUENCE,
			isVisible: true,
		},
		{
			menuId: L1_MENU_ID.GLOBAL_APP_LOOM,
			isVisible: true,
		},
		{
			menuId: L1_MENU_ID.GLOBAL_APP_ASSETS,
			isVisible: true,
		},
		{
			menuId: L1_MENU_ID.GLOBAL_APP_OPSGENIE,
			isVisible: true,
		},
		{
			menuId: L1_MENU_ID.GLOBAL_APP_GOALS,
			isVisible: true,
		},
		{
			menuId: L1_MENU_ID.GLOBAL_APP_TEAMS,
			isVisible: true,
		},
		{
			menuId: L1_MENU_ID.GLOBAL_APP_PROJECTS,
			isVisible: true,
		},
	],
};

// EXP: navx-1982-change-order-of-teams-and-goals
export const USER_NAVIGATION_CONFIGURATION_DEFAULT_GOALS_TEAMS_SWITCHED: JiraUserNavigationConfiguration =
	{
		navKey: 'JIRA_SIDEBAR',
		navItems: [
			{
				menuId: L1_MENU_ID.RECENT,
				isVisible: true,
			},
			{
				menuId: L1_MENU_ID.STARRED,
				isVisible: true,
			},
			{
				menuId: L1_MENU_ID.APPS,
				isVisible: true,
			},
			// See https://jplat.jira.atlassian.cloud/browse/BLU-3307
			// For the Dogfooding phase of Nav4 we are going to intentionally hide the Goals menu item.
			// Keeping code in comments so it can be easily reintroduced during EAP
			// {
			// 	menuId: L1_MENU_ID.GOALS,
			// 	isVisible: true,
			// },
			{
				menuId: L1_MENU_ID.ROADMAPS,
				isVisible: true,
			},
			{
				menuId: L1_MENU_ID.PLANS,
				isVisible: true,
			},
			{
				menuId: L1_MENU_ID.PROJECTS,
				isVisible: true,
			},
			{
				menuId: L1_MENU_ID.FILTERS,
				isVisible: true,
			},
			{
				menuId: L1_MENU_ID.DASHBOARDS,
				isVisible: true,
			},
			{
				menuId: L1_MENU_ID.OPERATIONS,
				isVisible: true,
			},
			{
				menuId: L1_MENU_ID.ITAM,
				isVisible: true,
			},
			{
				/* remove this on
				 * assets_as_an_app_v2 cleanup &&
				 */
				menuId: L1_MENU_ID.ASSETS,
				isVisible: true,
			},
			{
				menuId: L1_MENU_ID.TEAMS,
				isVisible: true,
			},
			{
				menuId: L1_MENU_ID.CUSTOMERS,
				isVisible: true,
			},
			{
				menuId: L1_MENU_ID.CUSTOMER_SERVICE,
				isVisible: true,
			},
			{
				menuId: L1_MENU_ID.HELP_CENTER_MANAGEMENT,
				isVisible: true,
			},
			{
				menuId: L1_MENU_ID.GLOBAL_APP_CONFLUENCE,
				isVisible: true,
			},
			{
				menuId: L1_MENU_ID.GLOBAL_APP_LOOM,
				isVisible: true,
			},
			{
				menuId: L1_MENU_ID.GLOBAL_APP_ASSETS,
				isVisible: true,
			},
			{
				menuId: L1_MENU_ID.GLOBAL_APP_OPSGENIE,
				isVisible: true,
			},
			{
				menuId: L1_MENU_ID.GLOBAL_APP_TEAMS,
				isVisible: true,
			},
			{
				menuId: L1_MENU_ID.GLOBAL_APP_GOALS,
				isVisible: true,
			},
			{
				menuId: L1_MENU_ID.GLOBAL_APP_PROJECTS,
				isVisible: true,
			},
		],
	};

export const USER_NAVIGATION_CONFIGURATION_DEFAULT_MENU_IDS: string[] =
	USER_NAVIGATION_CONFIGURATION_DEFAULT.navItems.map(({ menuId }) => menuId);

// EXP: navx-1982-change-order-of-teams-and-goals
export const USER_NAVIGATION_CONFIGURATION_DEFAULT_MENU_IDS_GOALS_TEAMS_SWITCHED: string[] =
	USER_NAVIGATION_CONFIGURATION_DEFAULT_GOALS_TEAMS_SWITCHED.navItems.map(({ menuId }) => menuId);
